const fn = {
  init: () => {
    const $requiredOptionsets = $('fieldset.optionset.requiredField')

    $requiredOptionsets.each((_, el) => {
      $(el).find('legend').html($(el).find('legend').text() + ' <sup>*</sup>')
    })
  }
}

export default {
  can: () => document.body.classList.contains('page-contact-us'),
  run: fn.init
}
